import * as React from 'react';
import AuthenticationNotifications from '@UI/Pages/Authentication/Shared/AuthenticationNotifications';
import CredentialsStep from '@UI/Pages/Authentication/Login/CredentialsStep';
import IdentificationStep from '@UI/Pages/Authentication/Login/IdentificationStep';
import SsoErrorBanner from '@UI/Pages/Authentication/Login/SsoErrorBanner';
import loginStepSignal, { resetLoginStep } from '@UI/Pages/Authentication/Login/Signals/loginStepSignal';
import { useSignalValue } from '@verclam/pulsar';
import { Card } from '@verclam/ui-kit';

/**
 * Two-step login (D-2): the address alone resolves which modes the domain allows
 * (`resolveAuthenticationModes`), then the second step renders password / SSO / both accordingly —
 * never both hidden, never a mode the organization has disabled.
 */
const LoginPage: React.FC = () => {
	const step = useSignalValue(loginStepSignal);

	React.useEffect(() => () => resetLoginStep(), []);

	return (
		<React.Fragment>
			<Card title="Connexion" width="100%" maxWidth="30rem">
				<SsoErrorBanner />
				{step.type === 'identification' ? <IdentificationStep /> : null}
				{step.type === 'credentials' ? <CredentialsStep /> : null}
			</Card>
			<AuthenticationNotifications />
		</React.Fragment>
	);
};

export default LoginPage;
